/* =========================================================
   WHYTABS · cart engine (drawer + /cart page)
   Server-rendered markup (snippets/wt-cart-body.liquid) refreshed with the
   Section Rendering API, so every text and rule stays editable in Customize.
   Public API: window.WTCart.open(), .close(), .refresh(), .add(items)
   ========================================================= */
(function () {
  'use strict';
  if (window.WTCart && window.WTCart.v === 2) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function D() { return document.getElementById('wt-cart'); }
  var lastFocus = null;

  // "Adding…" placeholder styles (shown instantly while Shopify adds the item).
  if (!document.getElementById('wt-cart-x-css')) {
    var css = document.createElement('style'); css.id = 'wt-cart-x-css';
    css.textContent = '.wt-cartx__adding{display:flex;align-items:center;gap:10px;margin:12px 20px 0;padding:14px 16px;border-radius:12px;border:1px dashed var(--wt-green,#2f7b20);background:linear-gradient(90deg,#f3f7f1 0%,#fff 50%,#f3f7f1 100%);background-size:200% 100%;animation:wt-adding 1.1s linear infinite;font-weight:700;font-size:14px;color:var(--wt-ink,#11110f)}.wt-cartx__adding-dot{width:10px;height:10px;border-radius:50%;background:var(--wt-green,#2f7b20);animation:wt-adding-dot .9s ease-in-out infinite;flex-shrink:0}@keyframes wt-adding{from{background-position:100% 0}to{background-position:-100% 0}}@keyframes wt-adding-dot{0%,100%{transform:scale(1)}50%{transform:scale(1.5)}}';
    document.head.appendChild(css);
  }

  function views() { return Array.prototype.slice.call(document.querySelectorAll('[data-wt-cart-view]')); }
  function sectionIds() {
    var ids = [];
    views().forEach(function (v) { var id = v.getAttribute('data-section'); if (id && ids.indexOf(id) < 0) ids.push(id); });
    return ids;
  }
  function setBusy(on) { views().forEach(function (v) { v.classList.toggle('is-busy', on); }); }
  function setStatus(msg) { views().forEach(function (v) { var el = v.querySelector('[data-cart-status]'); if (el) el.textContent = msg || ''; }); }

  function barState(v) {
    var f = v.querySelector('.wt-cartx__fill');
    var st = { w: f ? f.style.width : null, on: {} };
    v.querySelectorAll('[data-mark]').forEach(function (m) { st.on[m.getAttribute('data-mark')] = m.classList.contains('is-on'); });
    var sc = v.querySelector('.wt-cartx__scroll'); st.scroll = sc ? sc.scrollTop : 0;
    return st;
  }
  function animateBar(v, st) {
    var f = v.querySelector('.wt-cartx__fill');
    if (f && st.w !== null) {
      var target = f.style.width;
      f.style.transition = 'none'; f.style.width = st.w; void f.offsetWidth;
      f.style.transition = ''; f.style.width = target;
    }
    v.querySelectorAll('[data-mark]').forEach(function (m) {
      if (m.classList.contains('is-on') && st.on[m.getAttribute('data-mark')] === false) {
        setTimeout(function () { m.classList.add('is-pop'); }, 350);
      }
    });
    var sc = v.querySelector('.wt-cartx__scroll'); if (sc && st.scroll) sc.scrollTop = st.scroll;
  }

  function apply(sections) {
    if (!sections) return;
    views().forEach(function (v) {
      var html = sections[v.getAttribute('data-section')];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-wt-cart-view]');
      if (!fresh) return;
      var st = barState(v);
      v.innerHTML = fresh.innerHTML;
      animateBar(v, st);
    });
    var body = document.querySelector('[data-wt-cart-view] .wt-cartx');
    var count = body ? Number(body.getAttribute('data-count')) : null;
    if (count !== null) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? '(' + count + ')' : ''; });
    }
    document.dispatchEvent(new CustomEvent('wt:cart-updated', { detail: { count: count } }));
  }

  function refresh() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch(root + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(apply);
  }

  function post(path, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    setBusy(true); setStatus('');
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (j) {
      setBusy(false);
      if (j.sections) apply(j.sections); else return refresh();
      return j;
    }).catch(function (e) {
      setBusy(false);
      document.querySelectorAll('.wt-cartx__adding').forEach(function (n) { n.remove(); });
      setStatus((e && (e.description || e.message)) || 'Could not update your cart. Please try again.');
      throw e;
    });
  }


  // One-time "tablet flies into the cart" moment. Plays only the first time this browser adds to cart.
  var FLY_KEY = 'wt_fly_seen', flySeen = false;
  try { flySeen = window.localStorage.getItem(FLY_KEY) === '1'; } catch (e) {}
  function cartTarget() {
    var els = document.querySelectorAll('.wt-header [data-cart-open], [data-cart-open]');
    for (var i = 0; i < els.length; i++) { var r = els[i].getBoundingClientRect(); if (r.width && r.height && r.bottom > 0) return els[i]; }
    return null;
  }
  function fly(fromEl) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (flySeen || reduce || !fromEl || !fromEl.getBoundingClientRect || !document.body.animate) return Promise.resolve();
    flySeen = true;
    try { window.localStorage.setItem(FLY_KEY, '1'); } catch (e) {}
    var target = cartTarget();
    var a = fromEl.getBoundingClientRect();
    var b = target ? target.getBoundingClientRect() : { left: window.innerWidth - 60, top: 20, width: 40, height: 40 };
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, x1 = b.left + b.width / 2, y1 = b.top + b.height / 2;
    var tab = document.createElement('div');
    tab.className = 'wt-fly';
    tab.setAttribute('aria-hidden', 'true');
    tab.style.left = (x0 - 18) + 'px'; tab.style.top = (y0 - 18) + 'px';
    document.body.appendChild(tab);
    var dx = x1 - x0, dy = y1 - y0, lift = Math.min(160, Math.abs(dy) * 0.4 + 80);
    var anim = tab.animate([
      { transform: 'translate(0,0) scale(.4) rotate(0)', opacity: 0 },
      { transform: 'translate(0,-34px) scale(1.25) rotate(-30deg)', opacity: 1, offset: .18 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - lift) + 'px) scale(1) rotate(160deg)', opacity: 1, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.35) rotate(340deg)', opacity: .9 }
    ], { duration: 950, easing: 'cubic-bezier(.45,.05,.4,1)', fill: 'forwards' });
    return new Promise(function (resolve) {
      var done = function () {
        tab.remove();
        if (target) { target.classList.remove('wt-cart-bump'); void target.offsetWidth; target.classList.add('wt-cart-bump'); }
        resolve();
      };
      anim.onfinish = done;
      setTimeout(function () { if (tab.parentNode) done(); }, 1400);
    });
  }

  // Buy box (wt-core.js) fires wt:added right before calling open(): fly from the button that was clicked.
  var pendingFly = null, lastAtc = null; // fly kept for API; the drawer opening is the feedback now
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-wt-atc]'); if (b) lastAtc = b; }, true);
  document.addEventListener('wt:added', function () { pendingFly = null; });

  function skeleton(name) {
    views().forEach(function (v) {
      var sc = v.querySelector('.wt-cartx__scroll'); if (!sc) return;
      var row = document.createElement('div'); row.className = 'wt-cartx__adding';
      var dot = document.createElement('span'); dot.className = 'wt-cartx__adding-dot';
      var txt = document.createElement('span'); txt.textContent = 'Adding ' + (name || 'your item') + '…';
      row.appendChild(dot); row.appendChild(txt); sc.insertBefore(row, sc.firstChild); sc.scrollTop = 0;
    });
  }
  function show() {
    var dlg = D();
    if (dlg && !dlg.open && typeof dlg.showModal === 'function') dlg.showModal();
  }
  // Opens at once; content refreshes in the background (thin loading line, no fade).
  function open(opts) {
    lastFocus = document.activeElement;
    pendingFly = null;
    show();
    if (opts && opts.fresh) return Promise.resolve();
    setBusy(true);
    return refresh().then(function () { setBusy(false); }, function (e) { setBusy(false); throw e; });
  }
  function close() { var dlg = D(); if (dlg && dlg.open) dlg.close(); }
  function add(items) { return post('cart/add.js', { items: items }); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;
    var opener = t.closest('[data-cart-open]');
    if (opener && D()) { e.preventDefault(); open().catch(function () { window.location.href = root + 'cart'; }); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }

    var line = t.closest('[data-line-key]');
    if (line) {
      e.preventDefault();
      var q = Number(line.getAttribute('data-qty')), li = line.closest('.wt-cartx__line');
      if (li) {
        if (q === 0) { li.style.maxHeight = li.offsetHeight + 'px'; void li.offsetHeight; li.classList.add('is-leaving'); }
        else { li.classList.add('is-updating'); var n = li.querySelector('.wt-cartx__qty span'); if (n) n.textContent = q; }
      }
      post('cart/change.js', { id: line.getAttribute('data-line-key'), quantity: q }).catch(function () {
        if (li) { li.classList.remove('is-leaving', 'is-updating'); li.style.maxHeight = ''; }
      });
      return;
    }
    var sw = t.closest('[data-sub-switch]');
    if (sw) {
      e.preventDefault();
      post('cart/change.js', {
        id: sw.getAttribute('data-key'),
        quantity: Number(sw.getAttribute('data-qty')) || 1,
        selling_plan: Number(sw.getAttribute('data-plan'))
      }).then(function () {
        document.dispatchEvent(new CustomEvent('wt:switched-to-subscription'));
      }).catch(function () {});
      return;
    }
    var qa = t.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      qa.disabled = true; var old = qa.textContent; qa.textContent = 'Adding…';
      lastFocus = qa; show();
      skeleton((qa.getAttribute('aria-label') || '').replace(/^Add /, '').replace(/ to cart$/, ''));
      add([{ id: Number(qa.getAttribute('data-quick-add')), quantity: 1 }])
        .catch(function () { window.location.href = root + 'cart'; })
        .then(function () { qa.disabled = false; qa.textContent = old; });
      return;
    }
    var up = t.closest('[data-upsell-add]');
    if (up) {
      e.preventDefault();
      skeleton((up.getAttribute('aria-label') || '').replace(/^Add /, ''));
      add([{ id: Number(up.getAttribute('data-upsell-add')), quantity: 1 }]).catch(function () {});
    }
  });

  // Backdrop click closes; focus returns to the opener.
  document.addEventListener('click', function (e) { var dlg = D(); if (dlg && e.target === dlg) close(); });
  document.addEventListener('close', function (e) { if (e.target === D() && lastFocus && lastFocus.focus) lastFocus.focus(); }, true);

  // Theme editor: show the drawer while its settings are being edited.
  document.addEventListener('shopify:section:select', function (e) {
    var dlg = D(); if (dlg && e.target.contains(dlg) && !dlg.open) dlg.showModal();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var dlg = D(); if (dlg && e.target.contains(dlg)) close();
  });

  window.WTCart = { v: 2, open: open, close: close, refresh: refresh, add: add, fly: fly, show: show };
})();
